import { useMutation } from '@apollo/react-hooks'
import { BUSINESS_STATS_QUERY, UPLOAD_BUSINESS_CLIENTS } from '../../queries/businesses'
import { IUploadBusinessClientsData, IUploadBusinessClientsVariables } from '../../types/businesses'

export const useUploadBusinessClients = (businessId: number) => {
  return useMutation<IUploadBusinessClientsData, IUploadBusinessClientsVariables>(UPLOAD_BUSINESS_CLIENTS, {
    refetchQueries: [{ query: BUSINESS_STATS_QUERY, variables: { id: businessId } }],
  })
}
